import { urlUtils } from './utils'
import { interceptor } from './interceptor'
import { get, put } from './inner-store'
import { HASH_PARAM_NAME, STORE } from './constants'
import { iAuthProcessApi } from './types'

export type iAuthProcess = () => Promise<iAuthProcessApi>
const authProcess: iAuthProcess = async () => {
  let isAuthenticated = false
  /* ¿existe el hash */
  const hasHashInfo = urlUtils.checkUrlHashParams([HASH_PARAM_NAME])

  if (hasHashInfo) {
    const hash = urlUtils.getHashParam(HASH_PARAM_NAME)
    urlUtils.clearAllParams()
    const validateRequest = get(STORE.validateRequest)

    try {
      const { caseId, token, result, errorCode, errorDescription } =
        await validateRequest(hash!)
      put(STORE.access_token, token)

      interceptor()

      isAuthenticated = true

      return {
        isAuthenticated,
        caseId,
        result,
        errorDescription,
        errorCode,
      }
    } catch (error: any) {
      let errorResponse: iAuthProcessApi = {
        isAuthenticated,
      }
      if (error.response) {
        const { result, errorDescription, errorCode } =
          error.response.data

        errorResponse.result = result
        errorResponse.errorDescription = errorDescription
        errorResponse.errorCode = errorCode
      }
      console.error(error)
      return errorResponse
    }
  }

  return {
    isAuthenticated,
  }
}

export { authProcess }
